import {defineStore} from "pinia";
import http from "../api/http";
import {ElMessage} from "element-plus";
import {useSystem} from "./system";

export const useUser = defineStore('user', {
    state: () => ({
        token: '',
        userInfo: [],
        rechargeId: 0,
        rechargeDetail: [],
        google2faQrcode: null, //用户绑定google2faQrcode 二维码链接
        staticsData: [], //dashboard面板统计数据
        inviteLink: "", //用户邀请连接
        depositLog: [], //近一周的充值记录 和 所有记录共用
        withdrawLog: [], //近一周的提现记录 和 所有记录共用
        transactionsLog: [], //交易（收益）记录
        orderList: [], //订单记录
        orderDetail: [], //订单记录详情
        feedbackList: [], //工单列表
        feedbackDetail: [], //工单详情
        referralsLog: [], // 邀请记录（下级）
        referralsStatics: { //邀请统计数据 total_referrals:总邀请人数 total_rebate:总邀请奖励
            total_referrals: 0,
            total_rebate: 0
        },
        depositPage: {
            page: 1,
            limit: 10,
            total_page: 0,
            total: 0
        },
        withdrawPage: {
            page: 1,
            limit: 10,
            total_page: 0,
            total: 0
        },
        transactionsPage: {
            page: 1,
            limit: 10,
            total_page: 0,
            total: 0
        },
        orderPage: {
            page: 1,
            limit: 10
        },
        referralsPage:{
            page: 1,
            limit: 10,
            total_page: 0,
            total: 0
        },
        feedbackPage:{
            page: 1,
            limit: 10,
            total_page: 0,
            total: 0
        }
    }),
    getters: {
        getToken: (state) => {
            if (window.localStorage.getItem('mine-token')) {
                state.token = window.localStorage.getItem('mine-token')
            }
            return state.token
        },
        getUserInfo: (state) => state.userInfo,
        getStaticsData: (state) => state.staticsData,
        getInviteLink: (state) => {
            return `${window.location.origin}/Signup?invite_code=${state.userInfo?.invitation_code}`
        },

        getDepositLog: (state) => state.depositLog,
        getDepositPage: (state) => state.depositPage,

        getWithdrawLog: (state) => state.withdrawLog,
        getWithdrawPage: (state) => state.withdrawPage,

        getFeedbackLog: (state) => state.feedbackList,
        getFeedbackDetail: (state) => state.feedbackDetail,
        getFeedbackPage: (state) => state.feedbackPage,

        getReferralsList: (state) => state.referralsLog,
        getReferralsPage: (state) => state.referralsPage,
        getReferralsStatics: (state) => state.referralsStatics,

        getOrderList: (state) => state.orderList,
        getOrderDetail: (state) => state.orderDetail,

        getGoogle2faQrcode: (state) => state.google2faQrcode,

        getTransactionsLog: (state) => state.transactionsLog,
        getTransactionsPage: (state) => state.transactionsPage,
        getRechargeId: (state) => state.rechargeId,
        getRechargeDetail: (state) => state.rechargeDetail,
    },
    actions: {
        clearRechargeDetail() {
          this.rechargeDetail = []
        },
        clearToken() {
            this.token = ""
            window.localStorage.removeItem('mine-token')
        },
        setToken(token) {
            this.token = token
            window.localStorage.setItem('mine-token', this.token)
        },
        // 更新钱包地址
        async setWithdrawAddressApi(params) {
            await http.setWithdrawAddress(params).then(res => {
                ElMessage({
                    duration: 1500,
                    message: res.msg,
                    type: 'success',
                    onClose: () => {}
                })
            }).catch(err => {
                ElMessage({
                    duration: 1500,
                    message: err.msg,
                    type: 'error',
                    onClose: () => {}
                })
            })
        },
        // 修改支付密码
        async resetPayPwdApi(params) {
            await http.resetPayPwd(params).then(res => {
                ElMessage({
                    duration: 1500,
                    message: res.msg,
                    type: 'success',
                    onClose: () => {}
                })
            }).catch(err => {
                ElMessage({
                    duration: 1500,
                    message: err.msg,
                    type: 'error',
                    onClose: () => {}
                })
            })
        },
        // 修改登录密码
        async resetLoginPwdApi(params) {
            await http.resetLoginPwd(params).then(res => {
                ElMessage({
                    duration: 1500,
                    message: res.msg,
                    type: 'success',
                    onClose: () => {
                        this.clearToken()
                        http.logout().then()
                        window.location.href = '/Signin'
                    }
                })
            }).catch(err => {
                ElMessage({
                    duration: 1500,
                    message: err.msg,
                    type: 'error',
                    onClose: () => {}
                })
            })
        },
        updateUserInfoApi() {
            http.getUserInfo().then(res => {
                this.userInfo = res.data
            })
        },
        getUserStatisticsApi() {
            http.getUserStatistics().then(res => {
                this.staticsData = res.data
            })
        },
        //获取用户绑定谷歌验证器二维码
        googleAuthApi() {
            http.googleAuth().then(res => {
                this.google2faQrcode = res.data.qrCodeUrl
            })
        },
        async verifyGoogleAuthCodeApi(google_code) {
            await http.verifyGoogleAuthCode({google_code}).then(res => {
                ElMessage({
                    duration: 1500,
                    message: res.msg,
                    type: 'success',
                    onClose: () => {}
                })
            }).catch(err => {
                ElMessage({
                    duration: 1500,
                    message: err.msg,
                    type: 'error',
                    onClose: () => {}
                })
            })
        },
        // 查询近期
        getRecentDepositLogApi() {
            http.depositLog({page: 1, limit: 300, type: 'recent'}).then(res => {
                this.depositLog = res.data.list
            })
        },
        getRecentWithdrawLogApi() {
            http.withdrawLog({page: 1, limit: 300, type: 'recent'}).then(res => {
                this.withdrawLog = res.data.list
            })
        },
        feedbackChange(currentPage, pageSize) {
            this.depositPage.page = currentPage
            this.feedbackListApi('all')
        },
        // 查询所有分页
        feedbackListApi(type) {
            // type（0：待处理  1：已回复 2：已关闭   all：所有）
            http.getFeedbackList({...this.depositPage, status:type}).then(res => {
                this.feedbackList = res.data.list
                this.feedbackPage.total_page = res.data.total_page
                this.feedbackPage.total = res.data.total
            })
        },
        //创建工单
        async setFeedback(params) {
            await http.setFeedback(params).then(res => {
                ElMessage({
                    duration: 1500,
                    message: res.msg,
                    type: 'success',
                    onClose: () => {}
                })
            }).catch(err => {
                ElMessage({
                    duration: 1500,
                    message: err.msg,
                    type: 'error',
                    onClose: () => {}
                })
            })
        },
        // 获取工单详情
        feedbackDetailApi(feedback_id, cb = () => {}) {
            http.getFeedbackDetail({feedback_id}).then(res => {
                this.feedbackDetail = []
                this.feedbackDetail = res.data
                cb(true)
            })
        },
        depositChange(currentPage, pageSize) {
            this.depositPage.page = currentPage
            this.depositLogApi('all')
        },
        // 查询所有分页
        depositLogApi(type) {
            http.depositLog({...this.depositPage, type}).then(res => {
                this.depositLog = res.data.list
                this.depositPage.total_page = res.data.total_page
                this.depositPage.total = res.data.total
            })
        },
        withdrawChange(currentPage, pageSize) {
            this.withdrawPage.page = currentPage
            this.withdrawLogApi('all')
        },
        withdrawLogApi(type) {
            http.withdrawLog({...this.withdrawPage, type}).then(res => {
                this.withdrawLog = res.data.list
                this.withdrawPage.total_page = res.data.total_page
                this.withdrawPage.total = res.data.total
            })
        },
        transactionsChange(currentPage, pageSize) {
            this.transactionsPage.page = currentPage
            this.transactionsLogApi()
        },
        // 获取所有交易（收益）记录
        transactionsLogApi() {
            //type 只存在 5：购买产品      6 返利 利润
            http.transactionsLog(this.transactionsPage).then(res => {
                this.transactionsLog = res.data.list
                this.transactionsPage.total_page = res.data.total_page
                this.transactionsPage.total = res.data.total
            })
        },
        // 用户订单记录
        orderListApi() {
            http.orderList(this.orderPage).then(res => {
                this.orderList = res.data
            })
        },
        // 用户订单记录详情
        orderDetailApi(user_products_id) {
            http.orderDetail({user_products_id}).then(res => {
                this.orderDetail = res.data
            })
        },
        referralsChange(currentPage, pageSize) {
            this.referralsPage.page = currentPage
            this.referralsLogApi()
        },
        // 邀请记录（下级）
        referralsLogApi() {
            http.inviteList(this.referralsPage).then(res => {
                this.referralsLog = res.data.list
                this.referralsPage.total_page = res.data.total_page
                this.referralsPage.total = res.data.total
            })
            http.getUserStatistics().then(res => {
                this.referralsStatics.total_referrals = res.data.total_referrals
                this.referralsStatics.total_earnings = res.data.total_rebate
            })
        },
        //用户充值
        async userRechargeApi(params) {
            await http.userRecharge(params).then(res => {
                this.rechargeId = res.data.id
                ElMessage({
                    duration: 1500,
                    message: res.msg,
                    type: 'success',
                    onClose: () => {}
                })
            }).catch(err => {
                ElMessage({
                    duration: 1500,
                    message: err.msg,
                    type: 'error',
                    onClose: () => {}
                })
            })
        },
        //用户充值凭证上传接口
        async userRechargeUploadApi(params) {
            await http.userRechargeUpload(params).then(res => {
                ElMessage({
                    duration: 1500,
                    message: res.msg,
                    type: 'success',
                    onClose: () => {}
                })
            }).catch(err => {
                ElMessage({
                    duration: 1500,
                    message: err.msg,
                    type: 'error',
                    onClose: () => {}
                })
            })
        },
        async userRechargeDetailApi(params) {
            await http.userRechargeDetail(params).then(res => {
                this.rechargeDetail = res.data
            }).catch(err => {
            })
        },
        //用户提现
        async userWithdrawApi(params) {
            await http.userWithdraw(params).then(res => {
                ElMessage({
                    duration: 1500,
                    message: res.msg,
                    type: 'success',
                    onClose: () => {}
                })
            }).catch(err => {
                ElMessage({
                    duration: 1500,
                    message: err.msg,
                    type: 'error',
                    onClose: () => {}
                })
            })
        },
    }
})
